"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var i18next_1 = __importDefault(require("i18next"));
var empty_api_key_graphic_svg_1 = __importDefault(require("@assets/components/apiintegration/empty-api-key-graphic/empty-api-key-graphic.svg"));
var plus_icon_svg_1 = __importDefault(require("@assets/components/app/base-layout/plus-icon.svg"));
var react_redux_1 = require("react-redux");
var actions_1 = __importDefault(require("../../actions"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        root: (_a = {
                display: 'flex',
                flexDirection: 'column',
                marginTop: theme.spacing(6),
                alignItems: 'center'
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(12),
            },
            _a),
        emptyStateBodyText: {
            textAlign: 'center',
        },
        createApiKeyButton: {
            marginTop: '41px',
            width: '168px',
            minWidth: '90px',
            color: 'white',
            background: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
        plusIcon: {
            width: '17px',
        },
        emptyStateGraphic: {
            marginTop: '63px',
            marginBottom: '76px',
            position: 'relative',
        },
    });
});
/**
 * @component Default display component in place of api key generation.
 */
var NoApiKeyGraphic = function () {
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(core_1.Typography, { variant: "body1", className: classes.emptyStateBodyText },
            "GoGovSG API enables you to programmatically generate your short links.",
            react_1.default.createElement("br", null),
            "Refer to our",
            ' ',
            react_1.default.createElement("a", { href: i18next_1.default.t('general.links.apiDoc') },
                react_1.default.createElement("u", null, "API Documentation")),
            ' ',
            "for more information."),
        react_1.default.createElement(core_1.Button, { className: classes.createApiKeyButton, onClick: function () {
                dispatch(actions_1.default.generateApiKey());
            } },
            "Generate API Key\u00A0",
            react_1.default.createElement("img", { className: classes.plusIcon, src: plus_icon_svg_1.default, alt: "generate api key" })),
        react_1.default.createElement("div", { className: classes.emptyStateGraphic },
            react_1.default.createElement("img", { src: empty_api_key_graphic_svg_1.default, alt: "empty api key graphic" }))));
};
exports.default = NoApiKeyGraphic;
